module.exports = __webpack_public_path__ + "static/media/twilio-sms-logo.788d9e73.png";